import { For, Match, type Resource, Switch } from "solid-js";
import type {
	InfluencerPublicProfileResponse,
	ListBoardsResponse,
} from "@/client";
import { BoardsItem } from "~/modules/askgvt/boards/list/components/BoardsItem";
import "~/modules/askgvt/boards/list/boards.css";
import { Alert } from "@ui/Alert";
import { NoMatchingResults } from "@ui/molecules/NoMatchingResults/NoMatchingResults";
import { GhostBoardItem } from "~/modules/askgvt/boards/list/components/GhostBoardItem";

type Props = {
	influencer: InfluencerPublicProfileResponse["influencer"];
	boards: Resource<ListBoardsResponse>;
};

export const PublicBoards = (props: Props) => {
	return (
		<Switch>
			<Match when={props.boards.loading}>
				<div id="boards-list">
					<For each={Array(4)}>{() => <GhostBoardItem />}</For>
				</div>
			</Match>
			<Match when={props.boards.error}>
				<Alert variant="error">Error: {props.boards.error.message}</Alert>
			</Match>
			<Match when={props.boards()?.total === 0}>
				<NoMatchingResults message="This influencer has no public boards yet" />
			</Match>
			<Match when={props.boards()}>
				<div id="boards-list">
					<For each={props.boards()?.boards}>
						{(board) => <BoardsItem board={board} />}
					</For>
				</div>
			</Match>
		</Switch>
	);
};
